import React from 'react';
import {
  LOCATION_ASPROPIRGOS,
  LOCATION_ATHENS_INTERNATIONAL_AIRPORT,
  LOCATION_KIFISIA,
  LOCATION_ARGYROUPOLI,
  LOCATION_SKG,
} from 'components/subscriptions/constants';
import { URLS } from 'layouts/DrawerLayout/constants';
import { ColumnIcon, ListIcon } from 'components/common/ui/Vectors';

/* eslint-disable no-useless-escape */
export * from './orders';
export * from './users';
export const LIMIT = 50;
export const CURRENCY = 'EUR';
export const GENERIC_ERROR_MESSAGE =
  'We are having some issues, we will fix them ASAP';
export const SERVICE_POINTS_PAGE_SIZE = 500;
export const TENANT_NAMES = {
  0: 'instacar',
  1: 'instaride / kineo',
};
export const GRID_PAGE_SIZE_OPTIONS = [LIMIT, 100, 200, 500];

export const INPUT_FIELD_DEFAULT_HEIGHT = '40px';
export const INPUT_FIELD_POPPER_PLACEMENT = {
  start: {
    transform: `translate(0, ${INPUT_FIELD_DEFAULT_HEIGHT}) !important`,
  },
};

export const VIEW_MODES = {
  list: { value: 'list', icon: <ListIcon /> },
  kanban: { value: 'kanban', icon: <ColumnIcon /> },
};

export const DEFAULT_STREET_NAME = 'Πηγάσου';
export const DEFAULT_LOCATION = 'instacar point - Pigasou';
export const DEFAULT_STREET_NUMBER = '10';
export const DEFAULT_LOCALITY = 'Μαρούσι';
export const DEFAULT_POSTAL_CODE = '151 25';
export const DEFAULT_REGION = 'Περιφερειακή ενότητα Βορείου Τομέα Αθηνών';
export const DEFAULT_COUNTRY = 'Ελλάδα';
export const DEFAULT_LAT = 38.0325463;
export const DEFAULT_LNG = 23.8052333;

export const HQ_STREET_NAME = 'Παλαιά Τατοΐου';
export const HQ_STREET_NUMBER = '165';
export const HQ_LOCALITY = 'Κηφισιά';
export const HQ_POSTAL_CODE = '142 35';
export const HQ_REGION = 'Περιφερειακή ενότητα Βορείου Τομέα Αθηνών';
export const HQ_COUNTRY = 'Ελλάδα';
export const HQ_LAT = 38.102882;
export const HQ_LNG = 23.8134547;

export const PUBLIC_PATHS = ['/login'];

export const GRID_COLUMN_DEFAULT_PROPERTIES = {
  display: 'flex',
  minWidth: 80,
  headerAlign: 'left',
  align: 'left',
};

export const HANDOVER_CARS_TYPE = {
  DELIVERY: 0,
  RETURNS: 1,
};

export const HANDOVER_CARS_SIDE = {
  FRONT: 0,
  BACK: 1,
  LEFT: 2,
  RIGHT: 3,
  ABOVE: 4,
  INTERIOR: 5,
};

export const HANDOVER_CARS_LOCATIONS = {
  0: DEFAULT_LOCATION,
  1: LOCATION_KIFISIA,
  // 2: LOCATION_GERAKAS,
  3: LOCATION_ASPROPIRGOS,
  4: LOCATION_ARGYROUPOLI,
  5: 'instadelivery',
  6: 'Athens International Airport "Eleftherios Venizelos"',
  // 7: 'New Way',
  8: 'boxnow',
  9: LOCATION_SKG,
  10: 'Truck',
  11: 'Ship',
};

export const HANDOVER_CARS_STAGE = {
  0: 'Standard',
  2: 'Closed Contract',
  3: 'Temp',
  4: 'Predel',
};

export const AGENT_ROLES = {
  isAdmin: 'Admin',
  isCustomerCareAgent: 'CustomerCareAgent',
  isFleetOpsAssociate: 'FleetOpsAssociate',
  isProjectManager: 'ProjectManager',
  isSalesConsultant: 'SalesConsultant',
  isSupplyChainAssociate: 'SupplyChainAssociate',
  isPerformanceMarketingSpecialist: 'PerformanceMarketingSpecialist',
  isTreasurer: 'Treasurer',
  isGraphicDesigner: 'GraphicDesigner',
  isControllingManager: 'ControllingManager',
  isHeadOfMarketing: 'HeadOfMarketing',
  isAssistantAccountant: 'AssistantAccountant',
  isInsuranceSpecialist: 'InsuranceSpecialist',
  isSocialMediaManager: 'SocialMediaManager',
  isSeniorSalesConsultant: 'SeniorSalesConsultant',
  isCustomerSuccessCoordinator: 'CustomerSuccessCoordinator',
  isAccountant: 'Accountant',
  isARMTeamLead: 'ARMTeamLead',
  isProductDesigner: 'ProductDesigner',
  isCreditManager: 'CreditManager',
  isOperationsDirector: 'OperationsDirector',
  isAccidentsSeniorAssociate: 'AccidentsSeniorAssociate',
  isContentMarketingManager: 'ContentMarketingManager',
  isSeniorAccountant: 'SeniorAccountant',
  isBillingAssociate: 'BillingAssociate',
  isCreditControlAssociate: 'CreditControlAssociate',
  isCFO: 'CFO',
  isRepairsMaintenanceAssociate: 'RepairsMaintenanceAssociate',
  isFinancialController: 'FinancialController',
  isCreditControlLead: 'CreditControlLead',
  isCustomerSuccessTeamLead: 'CustomerSuccessTeamLead',
  isHeadOfProduct: 'HeadOfProduct',
  isFleetOpsTeamLead: 'FleetOpsTeamLead',
  isProductOperationsAssociate: 'ProductOperationsAssociate',
  isReturnsDeliveriesLead: 'ReturnsDeliveriesLead',
  isHRSupervisor: 'HRSupervisor',
  isSalesTeamLead: 'SalesTeamLead',
  isExternalPartner: 'ExternalPartner',
  isProductContentEditor: 'Product Content Editor',
  isHeadOfSourcing: 'HeadOfSourcing',
  isExternalAgent: 'ExternalAgent',
  isDriver: 'Driver',
  isCustomerSuccessManager: 'CustomerSuccessManager',
};

export const AGENT_ROLES_OPTIONS = {
  isAdmin: { text: 'Admin', value: 'Admin' },
  isCustomerCareAgent: {
    text: 'Customer Care Agent',
    value: 'CustomerCareAgent',
  },
  isFleetOpsAssociate: {
    text: 'Fleet Ops Associate',
    value: 'FleetOpsAssociate',
  },
  isProjectManager: { text: 'Project Manager', value: 'ProjectManager' },
  isSalesConsultant: { text: 'Sales Consultant', value: 'SalesConsultant' },
  isSupplyChainAssociate: {
    text: 'Supply Chain Associate',
    value: 'SupplyChainAssociate',
  },
  isPerformanceMarketingSpecialist: {
    text: 'Performance Marketing Specialist',
    value: 'PerformanceMarketingSpecialist',
  },
  isTreasurer: { text: 'Treasurer', value: 'Treasurer' },
  isGraphicDesigner: { text: 'Graphic Designer', value: 'GraphicDesigner' },
  isControllingManager: {
    text: 'Controlling Manager',
    value: 'ControllingManager',
  },
  isHeadOfMarketing: { text: 'Head Of Marketing', value: 'HeadOfMarketing' },
  isAssistantAccountant: {
    text: 'Assistant Accountant',
    value: 'AssistantAccountant',
  },
  isInsuranceSpecialist: {
    text: 'Insurance Specialist',
    value: 'InsuranceSpecialist',
  },
  isSocialMediaManager: {
    text: 'Social Media Manager',
    value: 'SocialMediaManager',
  },
  isSeniorSalesConsultant: {
    text: 'Senior Sales Consultant',
    value: 'SeniorSalesConsultant',
  },
  isCustomerSuccessCoordinator: {
    text: 'Customer Success Coordinator',
    value: 'CustomerSuccessCoordinator',
  },
  isAccountant: { text: 'Accountant', value: 'Accountant' },
  isARMTeamLead: { text: 'ARM Team Lead', value: 'ARMTeamLead' },
  isProductDesigner: { text: 'Product Designer', value: 'ProductDesigner' },
  isCreditManager: { text: 'Credit Manager', value: 'CreditManager' },
  isOperationsDirector: {
    text: 'Operations Director',
    value: 'OperationsDirector',
  },
  isAccidentsSeniorAssociate: {
    text: 'Accidents Senior Associate',
    value: 'AccidentsSeniorAssociate',
  },
  isContentMarketingManager: {
    text: 'Content Marketing Manager',
    value: 'ContentMarketingManager',
  },
  isSeniorAccountant: {
    text: 'Senior Accountant',
    value: 'SeniorAccountant',
  },
  isBillingAssociate: { text: 'Billing Associate', value: 'BillingAssociate' },
  isCreditControlAssociate: {
    text: 'Credit Control Associate',
    value: 'CreditControlAssociate',
  },
  isCFO: { text: 'CFO', value: 'CFO' },
  isRepairsMaintenanceAssociate: {
    text: 'Repairs Maintenance Associate',
    value: 'RepairsMaintenanceAssociate',
  },
  isFinancialController: {
    text: 'Financial Controller',
    value: 'FinancialController',
  },
  isCreditControlLead: {
    text: 'Credit Control Lead',
    value: 'CreditControlLead',
  },
  isCustomerSuccessTeamLead: {
    text: 'Customer Success Team Lead',
    value: 'CustomerSuccessTeamLead',
  },
  isHeadOfProduct: { text: 'Head Of Product', value: 'HeadOfProduct' },
  isFleetOpsTeamLead: {
    text: 'Fleet Ops Team Lead',
    value: 'FleetOpsTeamLead',
  },
  isProductOperationsAssociate: {
    text: 'Product Operations Associate',
    value: 'ProductOperationsAssociate',
  },
  isReturnsDeliveriesLead: {
    text: 'Returns Deliveries Lead',
    value: 'ReturnsDeliveriesLead',
  },
  isHRSupervisor: { text: 'HR Supervisor', value: 'HRSupervisor' },
  isSalesTeamLead: { text: 'Sales Team Lead', value: 'SalesTeamLead' },
  isExternalPartner: { text: 'External Partner', value: 'ExternalPartner' },
  isProductContentEditor: {
    text: 'Product Content Editor',
    value: 'ProductContentEditor',
  },
  isHeadOfSourcing: { text: 'Head Of Sourcing', value: 'HeadOfSourcing' },
  isDriver: { text: 'Driver', value: 'Driver' },
};

export const CONTACT_ROLES = [
  {
    text: 'Technician',
    value: 'Technician',
  },
  {
    text: 'Call Center Agent',
    value: 'Call Center Agent',
  },
  {
    text: 'Accounting',
    value: 'Accounting',
  },
  {
    text: 'Legal',
    value: 'Legal',
  },
  {
    text: 'Claims/Insurance Agent',
    value: 'Claims/Insurance Agent',
  },
];

export const ALLOWED_ARNM_AGENT_ROLES = new Set([
  AGENT_ROLES.isCustomerSuccessCoordinator,
  AGENT_ROLES.isCustomerSuccessManager,
  AGENT_ROLES.isCustomerSuccessTeamLead,
  AGENT_ROLES.isFleetOpsTeamLead,
  AGENT_ROLES.isRepairsMaintenanceAssociate,
  AGENT_ROLES.isInsuranceSpecialist,
]);

export const ENTITIES = {
  agents: 'agents',
  bookings: 'bookings',
  catalog: 'catalog',
  configurations: 'configurations',
  ebikes: 'ebikes',
  errors: 'errors',
  graphs: 'graphs',
  insurances: 'insurances',
  maps: 'maps',
  roadsideAssistances: 'roadsideAssistances',
  search: 'search',
  servicePoints: 'servicePoints',
  serviceVehicles: 'serviceVehicles',
  subscribers: 'subscribers',
  subscriptions: 'subscriptions',
  users: 'users',
  utilities: 'utilities',
  vehicles: 'vehicles',
};

export const SCOPES = {
  canCreate: 'write',
  canEdit: 'update',
  canDelete: 'delete',
  canView: 'read',
};

export const PROCUREMENT_STAGES = {
  CREATED: 0,
  ORDERED: 1,
  'IN CUSTOMS': 2,
  'PAYMENT PROCESS': 3,
  'DEALER PREPARATION': 4,
  FLEET: 5,
  DEFLEETED: 6,
  CANCELLED: 7,
};

export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const REGEX_PATTERNS = {
  Boolean: /test. *true,false/,
  Phone: /^\+[1-9]\d{7,14}$/i, // E.164 format
  Email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  String: /^$/,
  Numbers: /^[0-9]+$/,
  Letters: /^[^\d]*$/,
  Vin: /^(?=.*[A-HJ-NPR-Z])(?=.*\d)[A-HJ-NPR-Z0-9]{17}$/,
};

export const FILTER_RULE_ENUMS = {
  AndRuleType: 0,
  OrRuleType: 1,
  EmptyRuleType: 2,
  NotRuleType: 3,
  OrderedRuleType: 4,
  ComparableRuleType: 5,
  DynamicFilterFieldRuleType: 6,
  CompareDateRuleType: 7,
  IsAnyOfRuleType: 8,
  CompareStringRuleType: 9,
  ComparePriceRuleType: 10,
  DateBetween: 11,
  MatchesElementRuleType: 12,
  isEmpty: 18,
  noEmpty: 19,
};

export const FILTER_OPERATORS = {
  EQUAL: '=',
  NOT_EQUAL: '!=',
  GREATER_THAN: '>',
  LOWER_THAN: '<',
  GREATER_OR_EQUAL: '>=',
  LOWER_OR_EQUAL: '<=',
  CONTAINS: 'contains',
  BEGINS_WITH: 'beginsWith',
  ENDS_WITH: 'endsWith',
  BETWEEN: 'between',
};

export const FILTER_OPERATOR_ENUMS = {
  '=': 0,
  '!=': 1,
  '>': 2,
  '<': 3,
  '>=': 4,
  '<=': 5,
  contains: 6,
  beginsWith: 7,
  endsWith: 8,
  between: 9,
};

export const FILTER_RULE_OPERATORS = {
  AndRuleType: 0,
  OrRuleType: 1,
  EmptyRuleType: 2,
  NotRuleType: 3,
  OrderedRuleType: [
    { name: FILTER_OPERATORS.EQUAL, label: '=' },
    { name: FILTER_OPERATORS.NOT_EQUAL, label: '!=' },
    { name: FILTER_OPERATORS.GREATER_THAN, label: '>' },
    { name: FILTER_OPERATORS.GREATER_OR_EQUAL, label: '>=' },
    { name: FILTER_OPERATORS.LOWER_THAN, label: '<' },
    { name: FILTER_OPERATORS.LOWER_OR_EQUAL, label: '<=' },
  ],
  ComparableRuleType: [
    { name: FILTER_OPERATORS.EQUAL, label: '=' },
    { name: FILTER_OPERATORS.NOT_EQUAL, label: '!=' },
  ],
  DynamicFilterFieldRuleType: 6,
  CompareDateRuleType: [
    { name: FILTER_OPERATORS.EQUAL, label: '=' },
    { name: FILTER_OPERATORS.NOT_EQUAL, label: '!=' },
    { name: FILTER_OPERATORS.GREATER_THAN, label: '>' },
    { name: FILTER_OPERATORS.GREATER_OR_EQUAL, label: '>=' },
    { name: FILTER_OPERATORS.LOWER_THAN, label: '<' },
    { name: FILTER_OPERATORS.LOWER_OR_EQUAL, label: '<=' },
  ],
  IsAnyOfRuleType: 8,
  CompareStringRuleType: [
    { name: FILTER_OPERATORS.EQUAL, label: '=' },
    { name: FILTER_OPERATORS.NOT_EQUAL, label: '!=' },
    { name: FILTER_OPERATORS.GREATER_THAN, label: '>' },
    { name: FILTER_OPERATORS.GREATER_OR_EQUAL, label: '>=' },
    { name: FILTER_OPERATORS.LOWER_THAN, label: '<' },
    { name: FILTER_OPERATORS.LOWER_OR_EQUAL, label: '<=' },
    { name: FILTER_OPERATORS.CONTAINS, label: 'contains' },
    { name: FILTER_OPERATORS.BEGINS_WITH, label: 'begins with' },
    { name: FILTER_OPERATORS.ENDS_WITH, label: 'ends with' },
  ],
  ComparePriceRuleType: [
    { name: FILTER_OPERATORS.EQUAL, label: '=' },
    { name: FILTER_OPERATORS.NOT_EQUAL, label: '!=' },
    { name: FILTER_OPERATORS.GREATER_THAN, label: '>' },
    { name: FILTER_OPERATORS.GREATER_OR_EQUAL, label: '>=' },
    { name: FILTER_OPERATORS.LOWER_THAN, label: '<' },
    { name: FILTER_OPERATORS.LOWER_OR_EQUAL, label: '<=' },
  ],
  DateBetween: 11,
};

export const FILTER_FIELDS_TYPES = {
  Select: 'dropdown',
  MultiSelect: 'multiselect',
  Autocomplete: 'autocomplete',
  String: 'string',
  Number: 'number',
  Date: 'date',
  DateTime: 'dateTime',
  Boolean: 'boolean',
  Phone: 'phone',
  Email: 'email',
};

export const FILTER_FIELDS = {
  Price: {
    type: FILTER_FIELDS_TYPES.String,
    ruleType: FILTER_RULE_ENUMS.ComparePriceRuleType,
    pattern: REGEX_PATTERNS.String,
    operators: FILTER_RULE_OPERATORS.ComparePriceRuleType,
    inputType: 'number',
  },
  String: {
    type: FILTER_FIELDS_TYPES.String,
    ruleType: FILTER_RULE_ENUMS.ComparableRuleType,
    pattern: REGEX_PATTERNS.String,
    operators: FILTER_RULE_OPERATORS.CompareStringRuleType,
  },
  BookingPlate: {
    type: FILTER_FIELDS_TYPES.Autocomplete,
    ruleType: FILTER_RULE_ENUMS.ComparableRuleType,
    pattern: REGEX_PATTERNS.String,
    operators: FILTER_RULE_OPERATORS.ComparableRuleType,
  },
  Number: {
    type: FILTER_FIELDS_TYPES.Number,
    ruleType: FILTER_RULE_ENUMS.OrderedRuleType,
    pattern: REGEX_PATTERNS.String,
    operators: FILTER_RULE_OPERATORS.OrderedRuleType,
    inputType: 'number',
  },
  Select: {
    type: FILTER_FIELDS_TYPES.Select,
    ruleType: FILTER_RULE_ENUMS.ComparableRuleType,
    pattern: REGEX_PATTERNS.String,
    operators: FILTER_RULE_OPERATORS.ComparableRuleType,
    valueEditorType: 'select',
    values: [],
    inputType: 'dropdown',
  },
  MultiSelect: {
    type: FILTER_FIELDS_TYPES.MultiSelect,
    ruleType: FILTER_RULE_ENUMS.IsAnyOfRuleType,
    pattern: REGEX_PATTERNS.String,
    operators: FILTER_RULE_OPERATORS.ComparableRuleType,
    valueEditorType: 'multiselect',
    values: [],
    inputType: 'multiselect',
  },
  Autocomplete: {
    type: FILTER_FIELDS_TYPES.Autocomplete,
    ruleType: FILTER_RULE_ENUMS.ComparableRuleType,
    pattern: REGEX_PATTERNS.String,
    operators: FILTER_RULE_OPERATORS.ComparableRuleType,
    valueEditorType: 'autocomplete',
    values: [],
    inputType: 'autocomplete',
  },
  Date: {
    ruleType: FILTER_RULE_ENUMS.CompareDateRuleType,
    type: FILTER_FIELDS_TYPES.Date,
    pattern: REGEX_PATTERNS.String,
    operators: [
      ...FILTER_RULE_OPERATORS.CompareDateRuleType,
      { name: 'between', label: 'between' },
    ],
    inputType: 'date',
  },
  DateTime: {
    ruleType: FILTER_RULE_ENUMS.CompareDateRuleType,
    type: FILTER_FIELDS_TYPES.DateTime,
    pattern: REGEX_PATTERNS.String,
    operators: [
      ...FILTER_RULE_OPERATORS.CompareDateRuleType,
      { name: 'between', label: 'between' },
    ],
    inputType: 'dateTime',
  },
  DateRange: {
    ruleType: FILTER_RULE_ENUMS.CompareDateRuleType,
    type: FILTER_FIELDS_TYPES.Date,
    pattern: REGEX_PATTERNS.String,
    operators: [{ name: 'between', label: 'between' }],
    inputType: 'date',
  },
  Boolean: {
    type: FILTER_FIELDS_TYPES.Boolean,
    ruleType: FILTER_RULE_ENUMS.ComparableRuleType,
    pattern: REGEX_PATTERNS.Boolean,
    operators: FILTER_RULE_OPERATORS.ComparableRuleType,
    valueEditorType: 'checkbox',
    defaultValue: false,
    inputType: 'checkbox',
  },
  Phone: {
    type: FILTER_FIELDS_TYPES.Phone,
    pattern: REGEX_PATTERNS.Phone,
    ruleType: FILTER_RULE_ENUMS.CompareStringRuleType,
    inputType: 'number',
    operators: FILTER_RULE_OPERATORS.CompareStringRuleType,
  },
  Email: {
    type: FILTER_FIELDS_TYPES.Email,
    pattern: REGEX_PATTERNS.Email,
    ruleType: FILTER_RULE_ENUMS.ComparableRuleType,
    operators: FILTER_RULE_OPERATORS.CompareStringRuleType,
  },
};

export const BOARDS = {
  UNKNOWN: 0,
  RETURNS: 1,
  REPAIRS_MAINTENANCE: 2,
  SERVICES: 3,
  BUY_OUT: 4,
  ARM_ACCIDENTS: 5,
  ARM_REPAIRS: 6,
  ARM_MAINTENANCE: 7,
  GREEN_CARD: 8,
  TRAFFIC_OFFENSES: 9,
  SELL_REQUESTS: 10,
  BILLING_INSTACAR: 11,
  BILLING_INSTARIDE: 12,
  BILLING_REFUNDS: 13,
  BILLING_DAMAGES: 14,
  BILLING_OTHER: 15,
  DEFLEET: 16,
  BOOKINGS: 17,
  LOGISTICS: 18,
  GENERIC_TICKETS: 19,
  SUBSCRIPTIONS: 20,
  INSTATRADES: 21,
  SERVICE_INBOX: 22,
};

export const BOARDS_ID = {
  RETURNS: 'RET',
  REPAIRS_MAINTENANCE: 'RM',
  SERVICES: 'SER',
  BUY_OUT: 'BUY',
  ARM_ACCIDENTS: 'AC',
  ARM_REPAIRS: 'REP',
  ARM_MAINTENANCE: 'MAIN',
  GREEN_CARD: 'GC',
  TRAFFIC_OFFENSES: 'TROF',
  SELL_REQUESTS: 'VSL',
  BILLING_INSTACAR: 'BIC',
  BILLING_INSTARIDE: 'BIR',
  BILLING_REFUNDS: 'BR',
  BILLING_DAMAGES: 'BD',
  BILLING_OTHER: 'BO',
  DEFLEET: 'DEF',
  BOOKINGS: 'bookings',
  LOGISTICS: 'LOG',
  SUBSCRIPTIONS: 'subscriptions',
  INSTATRADES: 'instatrades',
  SERVICE_INBOX: 'serviceInbox',
  GENERIC_TICKETS: 'GE',
};

export const BOARDS_ENUMS = {
  // 0: { text: 'Unknown', value: BOARDS.UNKNOWN },
  1: { text: 'Returns', value: BOARDS.RETURNS, board: BOARDS_ID.RETURNS },
  // 2: { text: 'Repairs & Maintenance', value: BOARDS.REPAIRS_MAINTENANCE },
  3: { text: 'Services', value: BOARDS.SERVICES, board: BOARDS_ID.SERVICES },
  4: { text: 'Buy Out', value: BOARDS.BUY_OUT, board: BOARDS_ID.BUY_OUT },
  5: {
    text: 'ARM - Accidents',
    value: BOARDS.ARM_ACCIDENTS,
    board: BOARDS_ID.ARM_ACCIDENTS,
  },
  6: {
    text: 'ARM - Repairs',
    value: BOARDS.ARM_REPAIRS,
    board: BOARDS_ID.ARM_REPAIRS,
  },
  7: {
    text: 'ARM - Maintenance',
    value: BOARDS.ARM_MAINTENANCE,
    board: BOARDS_ID.ARM_MAINTENANCE,
  },
  8: {
    text: 'Green Card',
    value: BOARDS.GREEN_CARD,
    board: BOARDS_ID.GREEN_CARD,
  },
  9: {
    text: 'Traffic Offenses',
    value: BOARDS.TRAFFIC_OFFENSES,
    board: BOARDS_ID.TRAFFIC_OFFENSES,
  },
  10: {
    text: 'Sell Requests',
    value: BOARDS.SELL_REQUESTS,
    board: BOARDS_ID.SELL_REQUESTS,
  },
  11: {
    text: 'Billing - Instacar',
    value: BOARDS.BILLING_INSTACAR,
    board: BOARDS_ID.BILLING_INSTACAR,
  },
  12: {
    text: 'Billing - Instaride',
    value: BOARDS.BILLING_INSTARIDE,
    board: BOARDS_ID.BILLING_INSTARIDE,
  },
  13: {
    text: 'Billing - Refunds',
    value: BOARDS.BILLING_REFUNDS,
    board: BOARDS_ID.BILLING_REFUNDS,
  },
  14: {
    text: 'Billing - Damages',
    value: BOARDS.BILLING_DAMAGES,
    board: BOARDS_ID.BILLING_DAMAGES,
  },
  15: {
    text: 'Billing - Other',
    value: BOARDS.BILLING_OTHER,
    board: BOARDS_ID.BILLING_OTHER,
  },
  16: { text: 'Defleet', value: BOARDS.DEFLEET, board: BOARDS_ID.DEFLEET },
  17: { text: 'Bookings', value: BOARDS.BOOKINGS, board: BOARDS_ID.BOOKINGS },
  18: {
    text: 'Logistics',
    value: BOARDS.LOGISTICS,
    board: BOARDS_ID.LOGISTICS,
  },
  19: {
    text: 'Generic Tickets',
    value: BOARDS.GENERIC_TICKETS,
    board: BOARDS_ID.GENERIC_TICKETS,
  },
  20: {
    text: 'Subscriptions',
    value: BOARDS.SUBSCRIPTIONS,
    board: BOARDS_ID.SUBSCRIPTIONS,
  },
  21: {
    text: 'Instatrades',
    value: BOARDS.INSTATRADES,
    board: BOARDS_ID.INSTATRADES,
  },
  22: {
    text: 'Service Inbox',
    value: BOARDS.SERVICE_INBOX,
    board: BOARDS_ID.SERVICE_INBOX,
  },
  23: {
    text: 'Generic Tickets',
    value: BOARDS.GENERIC_TICKETS,
    board: BOARDS_ID.GENERIC_TICKETS,
  },
};

export const BOARDS_ID_TO_URLS_MAP = {
  RETURNS: URLS.handoverCarsReturns,
  BUY_OUT: URLS.buyout,
  ARM_ACCIDENTS: URLS.arnmAccidents,
  ARM_REPAIRS: URLS.arnmRepairs,
  ARM_MAINTENANCE: URLS.arnmMaintenance,
  GREEN_CARD: URLS.greenCard,
  TRAFFIC_OFFENSES: URLS.trafficOffenses,
  SELL_REQUESTS: URLS.sellRequests,
  BILLING_INSTACAR: URLS.billing,
  BILLING_INSTARIDE: URLS.billing,
  BILLING_REFUNDS: URLS.billing,
  BILLING_DAMAGES: URLS.billing,
  BILLING_OTHER: URLS.billing,
  SELL_VEHICLES: URLS.sellVehicles,
  DEFLEET: URLS.defleet,
  LOGISTICS: URLS.logistics,
  BOOKINGS: URLS.bookings,
  SUBSCRIPTIONS: URLS.subscriptions,
  INSTATRADES: URLS.tradeTickets,
  SERVICE_INBOX: URLS.serviceVehicles,
  GENERIC_TICKETS: URLS.genericTickets,
};

export const CHANGELOG_ITEMS = {
  TASK_CREATE: 0,
  TASK_FIELD_UPDATE: 1,
  BOARD_FIELD_UPDATE: 2,
};

export const CATALOG_TABS = {
  '': 0,
  properties: 1,
  media: 2,
  pricing: 3,
  documents: 4,
  vehicles: 5,
};

export const CATALOG_TABS_ENUMS = {
  0: '',
  1: 'properties',
  2: 'media',
  3: 'pricing',
  4: 'documents',
  5: 'vehicles',
};

export const ELECTRIC_VEHICLES_TYPES = ['mhev', 'hev', 'phev', 'bev'];
export const SERVICE_POINT_TABS = {
  '': 0,
  partnershipDetails: 1,
  reviews: 2,
};

export const SERVICE_POINT_TABS_ENUMS = {
  0: '',
  1: 'partnershipDetails',
  2: 'reviews',
};

export const ARNM_REASONS_ACCIDENTS = [
  { text: 'Ατύχημα/Συμβάν', value: 'AC14' },
  { text: 'Κλοπή', value: 'ST15' },
  { text: 'Θραύση Κρυστάλλων', value: 'GB16' },
];

export const ARNM_REASONS_MAP = {
  OT01: 'Other',
  RE02: 'Repair',
  SE03: 'Service',
  MA04: 'Malfunction',
  TI05: 'Change tires',
  CH06: 'Vehicle Check',
  KT07: 'KTEO',
  KK08: 'Κάρτα Καυσαερίων',
  PA09: 'Parktronic',
  RR10: 'Roof Rack',
  TW11: 'Tinted Windows',
  AN12: 'Ανάκληση',
  AL13: 'Αλυσίδες',
  AC14: 'Ατύχημα/Συμβάν',
  ST15: 'Κλοπή',
  GB16: 'Θραύση Κρυστάλλων',
  KE17: 'Κλειδιά',
};

export const SUBSCRIPTIONS_TYPES = {
  0: 'Standard',
  1: 'DriveHome',
  2: 'Closed Contract',
  3: 'Temp',
  4: 'Predel',
};

export const SUBSCRIPTIONS_STATUSES = {
  0: 'Created',
  1: 'For Delivery',
  2: 'Active',
  3: 'Expiring',
  4: 'Renewal',
  5: 'For Return',
  6: 'Ended',
  // 7: 'Inactive', // Removed per request in INS-4275
  8: 'Cancelled',
};

export const SUBSCRIPTIONS_BUNDLES_STATUSES = {
  0: 'Pending',
  1: 'Active',
  2: 'Cancelled',
  3: 'Completed',
};

export const SUBSCRIPTIONS_BUNDLES_TYPES = {
  0: 'Premium Insurance, Kilometers',
  1: 'Premium Insurance',
  2: 'Premium Insurance, Sales',
  3: 'Premium Insurance, Kilometers, Sales',
  4: 'Premium Insurance, Kilometers, Delivery',
  5: 'Premium Full',
};

export const SUBSCRIPTIONS_STATUSES_ENUM = {
  CREATED: 0,
  FOR_DELIVERY: 1,
  ACTIVE: 2,
  EXPIRING: 3,
  RENEWAL: 4,
  FOR_RETURN: 5,
  ENDED: 6,
  // INACTIVE: 7, // Removed per request in INS-4275
  CANCELLED: 8,
};

export const DELIVERY_INFO_STATUSES = {
  0: 'Delivery Ready',
  1: 'Delivery Option Selected',
  2: 'Delivery Planned',
  3: 'Delivery Completed',
  4: 'Delivery Cancelled',
  5: 'Key Delivered',
};

export const DELIVERY_INFO_STATUSES_ENUM = {
  DELIVERY_READY: 0,
  DELIVERY_OPTION_SELECTED: 1,
  DELIVERY_PLANNED: 2,
  DELIVERY_COMPLETED: 3,
  DELIVERY_CANCELLED: 4,
  KEY_DELIVERED: 5,
};

export const APPROVAL_STATUSES = {
  approved: 'Approved',
  rejected: 'Rejected',
  pending: 'Pending',
};

export const PRICING_TYPES = {
  open: 0,
  fixed: 1,
};
export const PRICING_TYPES_MAP = {
  0: 'Open',
  1: 'Fixed',
};
export const MONTHLY_KILOMETERS = [
  {
    text: '0.08',
    value: '0.08',
  },
  {
    text: '0.10',
    value: '0.10',
  },
  {
    text: '0.14',
    value: '0.14',
  },
  {
    text: '0.16',
    value: '0.16',
  },
  {
    text: '0.18',
    value: '0.18',
  },
];

export const PRICING_CONTRACT_PERIOD_OPTIONS = [
  { text: `12 μήνες`, value: 12 },
  { text: `24 μήνες`, value: 24 },
  { text: `36 μήνες`, value: 36 },
];

export const PRICING_EBIKES_CONTRACT_PERIOD_OPTIONS = [
  { text: `3 μήνες`, value: 3 },
  { text: `6 μήνες`, value: 6 },
];

export const CONTRACT_TYPES = {
  open: 0,
  fixed: 1,
};

export const SERVICE_POINT_STATUSES = {
  deactive: 0,
  active: 1,
};

export const FLEET_VEHICLE_DOC_ENUMS = {
  CarLicense: 0,
  KTEO: 23,
  VehicleInsurance: 25,
  Other: 27,
  ExhaustCard: 29,
  VehicleLeaseAgreement: 40,
  RetailPriceBeforeTaxCertificate: 42,
  VehicleCertificateOfConformity: 43,
  CodeRadio: 44,
  CodeVehicle: 45,
  VehicleVideo: 56,
  Invoice: 14,
  Contract: 20,
};

export const FLEET_VEHICLE_DOC_TYPES = [
  { value: 27, text: 'Άλλο' },
  { value: 0, text: 'Άδεια Κυκλοφορίας Οχήματος' },
  { value: 23, text: 'KTEO' },
  { value: 25, text: 'Ασφάλεια Οχήματος' },
  { value: 29, text: 'Κάρτα Καυσαερίων' },
  { value: 42, text: 'Βεβαίωση Λιανικής Τιμής Προ Φόρων' },
  { value: 45, text: 'Κωδικός Οχήματος' },
  { value: 44, text: 'Κωδικός Ραδιοφώνου' },
  { value: 40, text: 'Μισθωτήριο Συμβόλαιο Οχήματος' },
  { value: 43, text: 'Πιστοποιητικό Ταξινόμησης Οχήματος' },
  { value: 20, text: 'Σύμβαση' },
  { value: 14, text: 'Τιμολόγιο' },
];

export const CAMPAIGN_RULES_TYPES = {
  origin: 11,
  vehicleEngine: 13,
  skus: 15,
  vehicles: 16,
  prices: 17,
};

export const RESERVATIONS_TYPES = {
  free: { value: -1, text: 'Free' },
  reserved: { value: 0, text: 'Reserved' },
  onhold: { value: 1, text: 'On Hold' },
  forsale: { value: 2, text: 'For Sale' },
  fordefleet: { value: 3, text: 'For Defleet' },
  predeltemp: { value: 4, text: 'Predel/Temp' },
  booked: { value: 5, text: 'Booked' },
  forreplace: { value: 6, text: 'For Replace' },
  legal: { value: 7, text: 'Legal' },
  grandtheft: { value: 8, text: 'Grand Theft' },
  seasonalcars: { value: 9, text: 'Seasonal Cars' },
  permanenttemp: { value: 10, text: 'Permanent Temp' },
  rac: { value: 11, text: 'Rac' },
};

export const AVAILABILITY_STATUSES = {
  onlease: { value: 0, text: 'On Lease' },
  onleasearm: { value: 1, text: 'On Lease ARM' },
  forreturn: { value: 2, text: 'For Return' },
  arm: { value: 3, text: 'ARM' },
  vehicleinspectionpending: { value: 4, text: 'Vehicle Inspection Pending' },
  available: { value: 5, text: 'Available' },
  fordelivery: { value: 6, text: 'For Delivery' },
  forsale: { value: 7, text: 'For Sale' },
};
export const RESERVATIONS_SUBSCRIPTION_TYPES = {
  3: 'Temp',
  4: 'Predel',
};

export const REASONS_OF_REJECTION = [
  { text: 'Price too low', value: 'Price too low' },
  { text: 'Price too high', value: 'Price too high' },
  { text: 'Data inaccuracy', value: 'Data inaccuracy' },
  { text: 'Vehicle not for sale', value: 'Vehicle not for sale' },
  { text: 'Other (please specify)', value: 'Other' },
];

export const SUBSCRIBER_ROLES = {
  owner: { value: 1, text: 'OWNER' },
  driver: { value: 2, text: 'DRIVER' },
  admin: { value: 3, text: 'ADMIN' },
};

export const CANCELATION_REASON = [
  {
    text: 'Sold',
    value: 'sold',
  },
  {
    text: 'Not interested',
    value: 'not-interested',
  },
  {
    text: '0% Deposit requested',
    value: 'zero-percent-deposit-requested',
  },
  {
    text: 'Financial issues',
    value: 'financial-issues',
  },
  {
    text: 'Other',
    value: 'other',
  },
];

export const LEAD_QUALITY = [
  {
    text: 'Cold',
    value: 'cold',
  },
  {
    text: 'Hot',
    value: 'hot',
  },
  {
    text: 'Pending',
    value: 'pending',
  },
];
export const DRIVERS_TABS = {
  deliveries: 0,
  returns: 1,
  inspections: 2,
};

export const DELIVERY_RETURN_POINTS = [
  {
    text: DEFAULT_LOCATION,
    value: DEFAULT_LOCATION,
  },
  {
    text: LOCATION_ASPROPIRGOS,
    value: LOCATION_ASPROPIRGOS,
  },
  {
    text: LOCATION_ARGYROUPOLI,
    value: LOCATION_ARGYROUPOLI,
  },
  {
    text: 'instadelivery',
    value: 'instadelivery',
  },
  {
    text: 'Airport ATH',
    value: LOCATION_ATHENS_INTERNATIONAL_AIRPORT,
  },
  {
    text: LOCATION_SKG,
    value: LOCATION_SKG,
  },
];

export const LANGUAGES = [
  {
    text: 'Ελληνικά',
    value: 'el',
  },
  {
    text: 'English',
    value: 'en',
  },
];

export const BOOKING_LABELS = [
  {
    value: 'Blueground',
    text: 'Blueground',
    styles: {
      backgroundColor: (theme) => theme.palette.blues.babyBlue200,
      color: (theme) => theme.palette.blues.babyBlue900,
    },
  },
  {
    value: 'Blue',
    text: 'Blue',
    styles: {
      backgroundColor: (theme) => theme.palette.blues.blue200,
      color: (theme) => theme.palette.blues.blue900,
    },
  },
  {
    value: 'Heron',
    text: 'Heron',
    styles: {
      backgroundColor: (theme) => theme.palette.oranges.orange200,
      color: (theme) => theme.palette.oranges.orange900,
    },
  },
  {
    value: 'Viber',
    text: 'Viber',
    styles: {
      backgroundColor: (theme) => theme.palette.violets.violet200,
      color: (theme) => theme.palette.violets.violet900,
    },
  },
  {
    value: 'RAC',
    text: 'RAC',
    styles: {
      backgroundColor: (theme) => theme.palette.greens.green200,
      color: (theme) => theme.palette.greens.green900,
    },
  },
  {
    value: 'Instatrade',
    text: 'Instatrade',
    styles: {
      backgroundColor: (theme) => theme.palette.purples.purple200,
      color: (theme) => theme.palette.purples.purple900,
    },
  },
  {
    value: 'Car Swap',
    text: 'Car Swap',
    styles: {
      backgroundColor: (theme) => theme.palette.yellows.yellow200,
      color: (theme) => theme.palette.yellows.yellow900,
    },
  },
];

export const INSTACAR_BANK_ACCOUNTS = [
  { text: 'Eurobank', value: 'Eurobank', iban: 'GR8502600270000340202180074' },
  { text: 'Piraeus', value: 'Piraeus', iban: 'GR3001720130005013097449719' },
  {
    text: 'Alpha Bank',
    value: 'Alpha Bank',
    iban: 'GR6301401460146002002025547',
  },
  {
    text: 'National Bank',
    value: 'National Bank',
    iban: 'GR4101107100000071000308057',
  },
  {
    text: 'Optima Bank',
    value: 'Optima Bank',
    iban: 'GR2403400010010021524027197',
  },
  {
    text: 'Viva',
    value: 'Viva',
    iban: '',
  },
  {
    text: 'Cash',
    value: 'Cash',
    iban: '',
  },
  {
    text: 'Check',
    value: 'Check',
    iban: '',
  },
];

export const INSTACAR_PAYMENT_METHODS = [
  { text: 'Bank Deposit', value: 'Bank Deposit' },
  { text: 'Credit Card', value: 'Credit Card' },
  {
    text: 'Standing Order',
    value: 'Standing Order',
  },
];

export const GURU_LEASING_MAIL_EXTENSION = 'icommcallcenter.gr';

export const CATALOG_AVAILABILITIES = {
  unknownavailability: {
    id: -1,
    name: 'Unknown Availability',
  },
  readyfordelivery: {
    id: 0,
    name: 'Ready for Delivery',
  },
  new: {
    id: 1,
    name: 'New',
  },
  twodaydelivery: {
    id: 2,
    name: '2 Day Delivery',
  },
  available: {
    id: 3,
    name: 'Available',
  },
  comingsoon: {
    id: 4,
    name: 'Coming Soon',
  },
  soldout: {
    id: 5,
    name: 'Sold Out',
  },
  fordelivery: {
    id: 6,
    name: 'For Delivery',
  },
};

export const SKU_TYPES = {
  car: { text: 'Car', value: 0 },
  bike: { text: 'Bike', value: 1 },
  van: { text: 'Van', value: 2 },
  scooter: { text: 'Scooter', value: 3 },
  patini: { text: 'Patini', value: 4 },
};

export const FUEL_REMAINING_OPTIONS = [
  { text: '0/8', value: '0/8' },
  { text: '1/8', value: '1/8' },
  { text: '2/8', value: '2/8' },
  { text: '3/8', value: '3/8' },
  { text: '4/8', value: '4/8' },
  { text: '5/8', value: '5/8' },
  { text: '6/8', value: '6/8' },
  { text: '7/8', value: '7/8' },
  { text: '8/8', value: '8/8' },
];

export const ENTITY_TYPES_COMMENTS = {
  bookings: 0,
  serviceVehicles: 1,
  reservations: 2,
  taskBoardTasks: 3,
  returnTasks: 4,
  returnTaskBillings: 5,
  maintenanceTasks: 6,
  accidentsClaimsTasks: 7,
  repairsTasks: 8,
  greenCardTasks: 9,
  catalogs: 10,
  subscriptions: 11,
  subscriptionHandoverInfos: 12,
  vehicleLocations: 13,
  vehicleInsurances: 14,
  instatrade: 15,
  genericTickets: 16,
  vehicles: 17,
  user: 19,
};
